export const SECTION_TITLE = 'Offerte trovate';
export const SECTION_SINGLE_TITLE = 'Offerta trovata';
export const SECTION_DESCRIPTION = 'Ordina per: ';
export const DOWNLOAD_LIST = 'Scarica in formato .xlsx';

/**
 * Order  constants
 * @type {string}
 */

export const SORTS_RECEIVED = 'ideal/components/HorizontalCatalogFilter/SORTS_RECEIVED';
export const UPDATE_SORT = 'ideal/components/HorizontalCatalogFilter/UPDATE_SORT';

/**
 * Available filters constants
 * @type {string}
 */
export const TAGS_RECEIVED = 'ideal/components/HorizontalCatalogFilter/TAGS_RECEIVED';
export const SHOW_TAG = 'ideal/components/HorizontalCatalogFilter/SHOW_TAG';
export const SHOW_ALL = 'ideal/components/HorizontalCatalogFilter/SHOW_ALL';
export const HIDE_TAG = 'ideal/components/HorizontalCatalogFilter/HIDE_TAG';

/**
 * Active filters constants
 * @type {string}
 */
export const ADD_OPTION = 'ideal/components/HorizontalCatalogFilter/ADD_OPTION';
export const REMOVE_OPTION = 'ideal/components/HorizontalCatalogFilter/REMOVE_OPTION';
export const REMOVE_ALL = 'ideal/components/HorizontalCatalogFilter/REMOVE_ALL';
